var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentDeployedStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 70,
    fill: "none",
    viewBox: "0 0 200 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 199.967,
    height: 69,
    x: 0.033,
    y: 0.125,
    fill: "#2E1E88",
    rx: 6.266
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 199.967,
    height: 69,
    x: 0.033,
    y: 0.125,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 6.266
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 199.967,
    height: 69,
    x: 0.033,
    y: 0.125,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 6.266
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E1E88",
    d: "M.033 6.39A6.266 6.266 0 0 1 6.3.126h52.398v69H6.299A6.266 6.266 0 0 1 .033 62.86V6.391Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M.033 6.39A6.266 6.266 0 0 1 6.3.126h52.398v69H6.299A6.266 6.266 0 0 1 .033 62.86V6.391Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M.033 6.39A6.266 6.266 0 0 1 6.3.126h52.398v69H6.299A6.266 6.266 0 0 1 .033 62.86V6.391Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2.08,
    d: "m23.714 35.653-1.25-1.274 1.25-1.558-2.5-1.87-1.406 1.247-2.499-2.649 5.155-5.142c.469-.207 1.625-.436 2.5.312.874.748.364 1.974 0 2.493l-1.875 1.714h4.53c1.619-2.287 5.007-5.873 9.06-7.642M23.714 35.653l-2.187 2.31 4.53 4.518 2.03-2.37m-4.373-4.458 4.373 4.457m0 0 1.563 1.592 1.25-1.246 2.03 2.025-1.25 1.558 2.5 2.805 4.842-5.142c.365-.415.875-1.496 0-2.493-.874-.997-1.926-.415-2.343 0l-1.562 1.247V36.56c3.764-3.269 5.984-6.548 7.23-9.348m-5.668-5.928c2.206-.962 4.608-1.386 7.03-.772.187 1.31-.041 3.736-1.361 6.7m-5.669-5.928 5.669 5.928M21.839 42.17c-1.041-.83-3.499-1.776-4.999 1.091-1.5 2.867-1.874 5.038-1.874 5.765 2.083-.312 6.498-1.34 7.498-2.96 1-1.62 0-3.272-.625-3.895Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.872 6.39a5.091 5.091 0 0 1 5.091-5.09h128.772a5.091 5.091 0 0 1 5.091 5.09v56.47a5.091 5.091 0 0 1-5.091 5.09H64.963a5.091 5.091 0 0 1-5.09-5.09V6.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E1E88",
    strokeWidth: 2.35,
    d: "M59.872 6.39a5.091 5.091 0 0 1 5.091-5.09h128.772a5.091 5.091 0 0 1 5.091 5.09v56.47a5.091 5.091 0 0 1-5.091 5.09H64.963a5.091 5.091 0 0 1-5.09-5.09V6.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 2.35,
    d: "M59.872 6.39a5.091 5.091 0 0 1 5.091-5.09h128.772a5.091 5.091 0 0 1 5.091 5.09v56.47a5.091 5.091 0 0 1-5.091 5.09H64.963a5.091 5.091 0 0 1-5.09-5.09V6.39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 2.35,
    d: "M59.872 6.39a5.091 5.091 0 0 1 5.091-5.09h128.772a5.091 5.091 0 0 1 5.091 5.09v56.47a5.091 5.091 0 0 1-5.091 5.09H64.963a5.091 5.091 0 0 1-5.09-5.09V6.39Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#618DA5",
    fillRule: "evenodd",
    d: "M107.062 45.468c0 .292-.241.53-.537.53h-5.39a.533.533 0 0 1-.536-.53V23.717c0-.293.24-.53.536-.53h5.39c.296 0 .537.237.537.53v21.75Zm8.475-16.356c0 .297-.24.537-.537.537h-5.389a.537.537 0 0 1-.537-.537v-5.389c0-.296.241-.537.537-.537H115c.297 0 .537.24.537.537v5.39Zm8.297-2.695a3.23 3.23 0 1 1-6.46 0 3.23 3.23 0 0 1 6.46 0Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D0A2",
    fillRule: "evenodd",
    d: "M115.537 37.32c0 .296-.24.536-.537.536h-5.389a.537.537 0 0 1-.537-.537V31.93c0-.296.241-.537.537-.537H115c.297 0 .537.24.537.537v5.39Zm8.297-2.696a3.23 3.23 0 1 1-6.46 0 3.23 3.23 0 0 1 6.46 0Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#618DA5",
    fillRule: "evenodd",
    d: "M115.537 45.527c0 .296-.24.536-.537.536h-5.389a.537.537 0 0 1-.537-.536v-5.39c0-.296.241-.536.537-.536H115c.297 0 .537.24.537.536v5.39Zm8.297-2.696a3.23 3.23 0 1 1-6.46 0 3.23 3.23 0 0 1 6.46 0Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#618DA5",
    d: "M130.801 35.095c0-1.279.335-2.304 1.004-3.076.669-.778 1.536-1.167 2.602-1.167.517 0 1.004.12 1.461.359.462.24.857.577 1.183 1.012V27.98h1.501v11.145h-1.501v-1.15c-.31.413-.699.742-1.167.987a3.108 3.108 0 0 1-1.477.367c-1.071 0-1.941-.38-2.61-1.142-.664-.762-.996-1.792-.996-3.092Zm1.575 0c0 .848.22 1.544.661 2.088.446.539 1.039.808 1.778.808a2.7 2.7 0 0 0 1.298-.335c.413-.223.726-.503.938-.84v-3.443c-.212-.337-.525-.617-.938-.84a2.649 2.649 0 0 0-1.298-.343c-.739 0-1.332.272-1.778.816-.441.538-.661 1.235-.661 2.089Zm8.085-.017c0-.772.172-1.48.514-2.121a3.884 3.884 0 0 1 1.444-1.534 3.914 3.914 0 0 1 2.089-.571c1.186 0 2.135.413 2.847 1.24.718.822 1.077 1.863 1.077 3.125v.367h-6.38c.06.713.335 1.308.824 1.787.49.478 1.126.718 1.909.718.436 0 .868-.082 1.298-.245a3 3 0 0 0 1.093-.71l.702.987c-.822.805-1.901 1.208-3.239 1.208-1.213 0-2.214-.394-3.003-1.183-.783-.789-1.175-1.811-1.175-3.068Zm1.575-.579h4.928a2.756 2.756 0 0 0-.163-.832 2.681 2.681 0 0 0-.433-.767 2.004 2.004 0 0 0-.767-.588 2.599 2.599 0 0 0-1.093-.22c-.386 0-.737.074-1.052.22a2.048 2.048 0 0 0-.767.572 2.84 2.84 0 0 0-.457.775 2.824 2.824 0 0 0-.196.84Zm7.09-3.443h1.607l2.521 6.331 2.521-6.331h1.624l-3.329 8.069h-1.615l-3.329-8.069Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentDeployedStep);
export default __webpack_public_path__ + "static/media/environment-deployed-step.e6f68bf3bdd9c37da989ad4a3f509ba6.svg";
export { ForwardRef as ReactComponent };